import { render, staticRenderFns } from "./WallServices.vue?vue&type=template&id=540b157a&"
import script from "./WallServices.vue?vue&type=script&lang=js&"
export * from "./WallServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports